

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20fashion%20editorial%20flatlay%20with%20diverse%20colorful%20sneakers%2C%20graphic%20t-shirts%2C%20leather%20belts%2C%20designer%20fragrance%20bottles%2C%20and%20patterned%20tote%20bags%20arranged%20on%20crisp%20white%20marble%20surface%2C%20bright%20natural%20daylight%20streaming%20from%20large%20windows%2C%20modern%20lifestyle%20product%20photography%2C%20rich%20coral%20orange%20and%20olive%20green%20accents%20against%20clean%20white%20backdrop%2C%20professional%20composition%20with%20shallow%20depth%20of%20field%2C%20energetic%20and%20fresh%20aesthetic&width=1800&height=1000&seq=hero-bg-v2-2026&orientation=landscape"
          alt="Hipobuy Spreadsheet product research background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20 md:py-0">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            <span className="block font-sans font-light text-2xl md:text-3xl">Your Ultimate</span>
            <span className="block font-heading italic">Hipobuy Spreadsheet</span>
            <span className="block font-sans font-light text-2xl md:text-3xl">Resource Hub</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl leading-relaxed">
            Discover thousands of organized product resources, category-based spreadsheets, comparison guides, and expert shopping insights. Find better products faster.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Hipobuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-5 mt-8">
            <span className="flex items-center gap-1.5 text-xs text-background-50/70">
              <i className="ri-check-line text-accent-400"></i>
              Updated Resources
            </span>
            <span className="flex items-center gap-1.5 text-xs text-background-50/70">
              <i className="ri-check-line text-accent-400"></i>
              Organized Database
            </span>
            <span className="flex items-center gap-1.5 text-xs text-background-50/70">
              <i className="ri-check-line text-accent-400"></i>
              Beginner Friendly
            </span>
            <span className="flex items-center gap-1.5 text-xs text-background-50/70">
              <i className="ri-check-line text-accent-400"></i>
              Secure Browsing
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}